<template>
	<div class="page-container">
		<HeaderLayout :pagecode="'join'"></HeaderLayout>
		<div class="content">
	          <div class="main-content">
	   			    <h3 class="name-logo">로그인</h3>
					<p class="text-logo">지금 바로 노스트라 AI를 만나보세요</p>
		
					<div class="from-box">
						<form  id="submitForm" action="memberProc/memberLogin" novalidate callBack="completeLogin" @submit="formSubmit">
						<div class='form-group'>   
							<md-field>
								<label>아이디</label>
								<md-input name="uid" id="uid"  :required="true"></md-input>
						  	</md-field>
							<div class="md-error-box">아이디를 입력하세요</div>
						</div>
						<div class='form-group'>   
							<md-field :md-toggle-password="false">
								<label>비밀번호</label>
								<md-input type="password"  name="upass" id="upass" :required="true"></md-input>
							</md-field>
							<div class="md-error-box">비밀번호를 입력하세요</div>
						</div>	
						<div class="box-button">
							<md-button class="md-raised submit-button" style="background:#3D79FE;color:#fff;height:50px;" type="submit">로그인</md-button>
						</div>
						</form>
					</div>
					<div class="text-login">
					       <span @click="goPage('findId')">아이디 찾기</span><span class="text-border">|</span> <span @click="goPage('findPw')">비밀번호 찾기</span>
					  </div>
					  <div class="box-border">
					       <ul>
					           <li></li>
							   <li><span class="text-OR">OR</span></li>
							   <li></li>
						   </ul>
					  </div>
					  <div class="box-button-img" v-if="facebookView">
					       <button type="button" style="background:#5471AD;"  @click="snsLogin('fb')"><img src="../../assets/img/btn-facbook.png" width=8 height=8>페이스북 아이디로 가입</button>
					  </div>
					  <div class="box-button-img" v-if="naverView">
					   <button type="button" style="background:#22B600;" @click="snsLogin('nv')"><img src="../../assets/img/btn-naver.png" width=15 height=15>네이버 아이디로 가입</button>
					  </div>
					  <div class="box-button-kakao"  v-if="kakaoView">
				       <button type="button" style="background:#FEF200;"  @click="snsLogin('ko')"><img src="../../assets/img/btn-talk.png" width=20 height=20>카카오톡 아이디로 가입</button>
					  </div>
					   <p class="text">
					        아직 회원이 아니신가요?<span class="text-name" @click="goPage('join')">회원가입</span>
					   </p> 

			</div>	
		</div>
		<FooterLayout></FooterLayout>
	</div>	
</template>


<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'

export default {
  name: 'MemberLogin',
  components: {
	  HeaderLayout,
	  FooterLayout,
  },
  data () {
	
	return {
  	    snsInfo:{},
		facebookView:true,
		naverView:true,
		kakaoView:true,
   }
  },
  created() {

	  this.getData()
  },
  methods: {
	  getData() {
		  var obj = this;
		  this.$form.sendPost({},'setting/getSnsConfig',function(resp) {
			 obj.snsInfo	= resp;
			 //console.log(resp);
			 if(obj.snsInfo.use_ka!='yes') {
				obj.kakaoView = false;
			 }
			 if(obj.snsInfo.use_nv!='yes') {
				obj.naverView = false;
				
			 }
			if(obj.snsInfo.use_fb!='yes') {
				obj.facebookView = false;
			 }
		  },'multi');
	  },
	  formSubmit(e) {
		
		var obj = this;
		this.$form.validate($('#submitForm'),e,function(resp) {
			var result = resp.result;
			var params = {}
		  	switch(result) {
			  case 'noid':
			  case 'nopw':
				  params.content = '잘못된 아이디 또는 비밀번호입니다';
				  
			  break;
			  case 'noauth':
				  params.content = '인증되지 않은 아이디 입니다';	
			  break;
			  default:
				  sessionStorage.setItem('memberkey',resp.memberkey);
				  sessionStorage.setObject('memberInfo',resp.userInfo);
				  var params = {};
				  params.content = '로그인 되었습니다';
				  params.doAction = function() {
					obj.$router.push({path:'/'});
				  }
			  break;
		   }
		   obj.$eventBus.$emit('dialogOpen',params);

		});
		
	  },
	  
	  goPage(cmd) {
		 switch(cmd) {
			case 'join':
				var url = '/member/join';
			break;
			case 'findId':
				var url = '/member/findPw/id';
			break;
			case 'findPw':
				var url = '/member/findPw/pw';
			break;
			default:
				var url = cmd;
			break;
		 }
		 this.$router.push({path:url});
	  },
	  snsLogin(type) {
		    var info = this.snsInfo;
			var url = 'https://duckku.com/memberProc/snsCallBack?type=';

			switch(type) {
				case 'nv': // 네이버
					if(!info.key_nv || !info.pw_nv || !info.token_nv) {
						var params = {};
						params.content = '네이버 로그인을 이용할수 없습니다';
						this.$eventBus.$emit('dialogOpen',params);
						return;
					}
					url+= 'n';
					location.href = 'https://nid.naver.com/oauth2.0/authorize?client_id='+info.key_nv+'&response_type=code&redirect_uri='+encodeURIComponent(url)+'&state='+info.token_nv;
				break;
				case 'ko': // 카카오
					
					if(!info.key_ka) {
						var params = {};
						params.content = '카카오톡 로그인을 이용할수 없습니다';
						this.$eventBus.$emit('dialogOpen',params);
						return;
					}
					
					location.href = "https://kauth.kakao.com/oauth/authorize?client_id="+info.key_ka+"&redirect_uri="+url+"k&response_type=code";
					
				break;
				case 'fb': // 페이스북
					if(!info.key_fb || !info.pw_fb) {
						var params = {};
						params.content = '페이스북 로그인을 이용할수 없습니다';
						this.$eventBus.$emit('dialogOpen',params);
						return;
					}
					location.href = "https://graph.facebook.com/oauth/authorize?client_id="+info.key_fb+"&redirect_uri="+url+"f&scope=email,public_profile";
				break;
			}
	  },
	  
  },
  mounted() {
	$('.content').css('min-height',$('body').height()-300);
  }

}
</script>

<style lang="scss" scoped>
.page-container {
	width:100%;
	min-height:calc(100vh);
	background:#fff;
	padding:0;
	margin:0;
	padding:150px 0 0 0; 
	.content   {
						  width:100%;
						  padding:0 0 100px 0; 
					      font-family: 'Nanum Gothic', sans-serif;
						  background:#fff;
						  .main-content             {
						  				width:320px;
										margin:0 auto;
										.name-logo			{
													font-size:25px;
													color:#333333;
													font-weight:normal;
										}
										.text-logo           {
													font-size:12px;
													color:#999;
													margin:15px 0 10px 0;
										}
										.box-text              {
													margin-top:10px;
										           .text-label           {
										           			font-size:12px;
										           			color:#CECECE;
										           }
										           .text-box-input         {
										           			width:310px;
										           			height:45px;
															border-bottom:2px solid #F0F0F0;
										           			input          {
										           					 width:310px;
										           			         height:43px;
										           					 line-height:45px;
																	 border:none;
																	 outline:none;
										           			}
										           }
										}
										.box-button            {
													width:310px;
													margin:15px 0;
													.md-button          {
															  width:310px;
													          height:42px;
															  border:none;
															  outline:none;
															  border-radius:35px;
															  background:#3D79FE;
															  color:#fff;
															  text-align:center;
															  line-height:42px;
													}
										}
										.text-login            {
													text-align:center;
													font-size:13px;
													color:#3D79FE;
													font-weight:bold;
													.text-border          {
																display:inline-block;
																color:#999999;
													}
													span {
														padding-right:10px;
														cursor:pointer;
													}
													span:last-child {
														padding-right:0;
													}

										}
										.box-border             {
													 margin:25px 0 9px;
													  ul              {
													  			display:flex;
																li           {
																		width:130px;
																		height:1px ;
																		background:#CCCCCC;
																		
																		&:nth-child(2)     {
																				     width:50px;
																					 height:10px;
																					 background:#fff;
																					 line-height:10px;
																					 position:relative;
																					 .text-OR         {
																					 			display:inline-block;
																								position:absolute;
																								top:-5px;
																								left:50%;
																								margin-left:-10px;
																					 }
																		}
																}
													  }
										}
										.box-button-img          {
													width:310px;
													margin-top:16px;
													button             {
																cursor:pointer;
																width:310px;
																height:45px;
																border:none;
																outline:none;
																border-radius:35px;
																color:#fff;
																text-align:center;
																line-height:45px;
																font-size:13px;
																img              {
																		  margin-right:8px;
																}
													}
										}
										.box-button-kakao         {
													width:310px;
													margin:16px 0;
													button             {
																cursor:pointer;
																width:310px;
																height:45px;
																border:none;
																outline:none;
																border-radius:35px;
																color:#3B1F1E;
																text-align:center;
																line-height:45px;
																font-size:13px;
																img              {
																		  margin-right:8px;
																}
													}
										}
										.text              {
													text-align:center;
													font-size:13px;
													color:#999999;
													margin-top:5px;
													.text-name           {
																display:inline-block;
																color:#3D79FE;
																margin-left:10px;
																cursor:pointer;
													}
										}
						  }
			}
}


</style>